import { useMemo } from "react"

import { createBrowserRouter, RouterProvider } from "react-router-dom"

import dashboardCatalogRoutes from "./DashboardCatalogRoutes"
import dashboardLookbookRoutes from "./DashboardLookbooksRoutes"
import dashboardStoreRoutes from "./DashboardStoresRoutes"
import quickSendRoutes from "./QuickSendsRoutes"

const createRouter = () =>
  createBrowserRouter(
    [...dashboardCatalogRoutes(), ...dashboardStoreRoutes(), ...dashboardLookbookRoutes(), ...quickSendRoutes()],
    {}
  )

/**
 * Renders the controller.
 * @returns The rendered component.
 */
export function Controller() {
  const router = useMemo(createRouter, [])

  return <RouterProvider router={router} />
}
